module.exports = __webpack_public_path__ + "static/media/carousel_img6.405debff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/carousel_img6.jpg
// module id = 368
// module chunks = 0